import { render, staticRenderFns } from "./AddKeycloakButton.vue?vue&type=template&id=ac9a99d6&scoped=true"
import script from "./AddKeycloakButton.vue?vue&type=script&lang=js"
export * from "./AddKeycloakButton.vue?vue&type=script&lang=js"
import style0 from "./AddKeycloakButton.vue?vue&type=style&index=0&id=ac9a99d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9a99d6",
  null
  
)

export default component.exports